import React from "react";
import { CircularProgress } from "@material-ui/core";

export const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const {
    children,
    onLoadMore,
    hasNextPage,
    isFetchingNextPage,
    scrollRef,
    listboxRef,
    ...rest
  } = props;

  const handleScroll = (e) => {
    scrollRef.current = e.currentTarget.scrollTop;

    if (
      e.currentTarget.scrollTop + e.currentTarget.clientHeight >=
      e.currentTarget.scrollHeight - 20
    ) {
      if (hasNextPage && !isFetchingNextPage) {
        onLoadMore();
      }
    }
  };

  return (
    <ul
      {...rest}
      ref={(node) => {
        listboxRef.current = node;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
      }}
      onScroll={handleScroll}
      style={{ maxHeight: 350, overflow: "auto" }}
    >
      {children}
      {isFetchingNextPage && (
        <li style={{ textAlign: "center", padding: 10 }}>
          <CircularProgress size={20} />
        </li>
      )}
    </ul>
  );
});
